/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Force_TakeoverInputs */



/**
* | output |
* | --- |
* | "Take Over" |
*
* @param {Offline_Force_TakeoverInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_force_takeover = /** @type {((inputs?: Offline_Force_TakeoverInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Force_TakeoverInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reprendre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tomar control")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assumir controle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prendi controllo")
	return /** @type {LocalizedString} */ ("Take Over")
});